import { usePaginationParams } from 'hooks';
import { Outlet } from 'react-router-dom';
import { TicketSelectionList } from '../component/ticket-selection-table/ticket-selection-list';
import { useGetTicketSelectionList } from '../use-cases/get-ticket-selection';
import { TicketSelectionTopBar } from '../component/top-bar/ticket-selection-topbar';
import { TicketSelFilterFormValues, TicketSelFilterFormValuesPaginated } from '../component/ticket-selection-filter-form/type';

const getInitialFilterValues: TicketSelFilterFormValues = {
    SearchFirstName: undefined,
    SearchLastName: undefined,
    SearchEmail: undefined,
    SearchEventName: undefined,
};

export const TicketSelectionView = () => {
    const { params, updateParams, resetPage } = usePaginationParams<TicketSelFilterFormValuesPaginated>({
        page: 1,
        size: 10,
        ...getInitialFilterValues,
    });
    const { data, refetch, isFetching } = useGetTicketSelectionList(params, { retry: false });
    const handleFiltersChange = (values: TicketSelFilterFormValuesPaginated) => {
        updateParams(values);
        resetPage();
        refetch()
    };

    return (

        <>
            <TicketSelectionTopBar
                handleFilter={handleFiltersChange}
                getInitialFilterValues={getInitialFilterValues}
            // refetch={""}
            />
            <TicketSelectionList
                isSocialListLoading={isFetching}
                DeliveryList={data}
                tableParams={params}
                updateParams={updateParams}
                refetch={refetch}

            />
            <Outlet />
        </>
    );
};
